var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-edicion',[_c('page-header',{attrs:{"title":"Crear contrato","back-to":"/contratos"}}),_c('formulario-contrato-cliente',{attrs:{"contrato-cliente":_vm.contratoCliente},on:{"submit":_vm.insertar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }